import React from 'react';
import { Row, Col, Typography } from 'antd';
import Card from '../card/Card';
import { useTheme } from '../../contexts/ThemeContext';

const { Text } = Typography;

const ProjectStatistics = ({ project }) => {
  const { theme } = useTheme();
  const stats = [
    {
      label: 'Syncs Conectados',
      value: project.syncs?.length || project.connectedErps || 0,
      color: '#1890ff'
    },
    {
      label: 'Relatórios Gerados',
      value: project.reports?.length || 0,
      color: '#1890ff'
    }
  ];

  return (
    <Card 
      title={<span style={{ fontSize: 16, fontWeight: 600 }}>Estatísticas do Projeto</span>}
      style={{ marginBottom: 24 }}
    >
      <Row gutter={[16, 16]}>
        {stats.map((stat, index) => (
          <Col span={12} key={index}>
            <div>
              <Text style={{ 
                color: '#8c8c8c', 
                fontSize: 12,
                display: 'block',
                marginBottom: 4
              }}>
                {stat.label}
              </Text>
              <div style={{ 
                fontSize: stat.fontSize || 32, 
                fontWeight: 600, 
                color: stat.color,
                lineHeight: 1
              }}>
                {stat.value}
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </Card>
  );
};

export default ProjectStatistics; 